import React, { useState } from 'react';
import './PublicationsListReadOnly.scss';
import { usePublications } from '../../services/publicationsService.js';
import FileTypeIcon from './FileTypeIcon.jsx';
// Read-only publications list for use in outlooks and non-admin views
// Accepts 'tags' (array) or 'tag' (string) prop to filter publications

const COLLAPSE_COUNT = 2;

export default function PublicationsListReadOnly({ tag, tags }) {
  const { data: pubs, loading, error } = usePublications({ tags: tags || (tag ? [tag] : undefined) });
  const [expanded, setExpanded] = useState(false);

  console.log('PublicationsListReadOnly - pubs:', pubs, 'loading:', loading, 'error:', error);

  if (loading) return <div className="publications-list-empty">Loading publications...</div>;
  if (error) return <div className="publications-list-empty" style={{ color: 'red' }}>{error}</div>;
  if (!pubs || pubs.length === 0) {
    return <div className="publications-list-empty">No publications available.</div>;
  }

  const hasMore = pubs.length > COLLAPSE_COUNT;
  const visiblePubs = hasMore && !expanded ? pubs.slice(0, COLLAPSE_COUNT) : pubs;

  return (
    <div style={{ maxWidth: 400 }}><div className="publications publications--bordered"><h3 className="publications__title">Latest Publications</h3>

      <ul className="publications-list-readonly">
        {visiblePubs.map((pub, idx) => (
          <li key={pub.name + idx} className="publications-list-item" style={{ margin: 0, marginBottom: '12px' }}>
            <a href={pub.sasUrl} download target="_blank" rel="noopener noreferrer" style={{ display: 'flex', alignItems: 'flex-start', gap: '6px' }}>
              <span className="pub-file-icon" style={{ marginRight: 8 }}><FileTypeIcon fileName={pub.name} /></span>
              <div className="pub-title-description">
                <div className="pub-title">
                  {pub.metadata?.title || pub.name}
                </div>
                {pub.metadata?.description && (
                  <div className="pub-description">{pub.metadata.description}</div>
                )}
              </div>

            </a>
          </li>
        ))}
      </ul>
      {hasMore && (
        <button className="pub-toggle" onClick={() => setExpanded(e => !e)}>
          {expanded ? 'Show fewer' : `Show all ${pubs.length}`}
        </button>
      )}
    </div></div>
  );
}


